import { getBlockchainAuditData } from "graphql/wire-transfers/queries";
import { useSubscribeToSocketEvent } from "hooks/useSubscribeToSocketEvent";
import { useState } from "react";
import { useQuery } from "react-query";
import { useParams } from "react-router-dom";
import { TransferBlockchainData } from "../../types";
import { InfoDeliveryAudit } from "./types";

export const useModalAudit = (transfer: TransferBlockchainData) => {
  const { id: orderId } = useParams<{ id: string }>();
  const [auditData, setAuitData] = useState<InfoDeliveryAudit | null>(null);
  const [isLoadingData, setIsLoadingData] = useState<boolean>(true);

  const {
    isLoading: isRequestingDataLoading
  } = useQuery(["blockchainAuditData", transfer.reference], () => getBlockchainAuditData({ dataId: orderId, reference: transfer.reference }), {
    onSuccess: (response) => {
      if (response) {
        setIsLoadingData(response.getBlockchainAudit);
      }
    }
  });

  useSubscribeToSocketEvent({
    eventKey: "info-delivery",
    callback: (data: InfoDeliveryAudit) => {
      if (data && data.kind === "audit") {
        setAuitData(data);
        setIsLoadingData(false);
      }
    }
  });

  return {
    auditData,
    isLoading: isRequestingDataLoading || isLoadingData
  };
};